/**
 * Phone chrome detection. iOS “Request Desktop Website” reports a wide
 * viewport and a Macintosh UA; the device is still a phone.
 */
export function isPhoneChrome(input: {
  innerWidth: number
  sm: number
  standalone?: boolean
  maxTouchPoints?: number
  userAgent?: string
  platform?: string
  hoverNonePointerCoarse?: boolean
}): boolean {
  if (input.innerWidth < input.sm) return true
  if (input.hoverNonePointerCoarse) return true
  if (input.standalone && (input.maxTouchPoints ?? 0) > 1) return true
  const ua = input.userAgent ?? ''
  if (/iPhone|iPod|iPad/.test(ua)) return true
  const touchMac =
    (input.platform === 'MacIntel' || /Macintosh/.test(ua)) && (input.maxTouchPoints ?? 0) > 1
  return touchMac
}

export function readNavigatorPhoneChrome(sm: number): boolean {
  if (typeof window === 'undefined' || typeof navigator === 'undefined') return false
  const nav = navigator as Navigator & { standalone?: boolean }
  return isPhoneChrome({
    innerWidth: window.innerWidth,
    sm,
    standalone:
      nav.standalone === true ||
      window.matchMedia?.('(display-mode: standalone)').matches === true,
    maxTouchPoints: nav.maxTouchPoints,
    userAgent: nav.userAgent,
    platform: nav.platform,
    hoverNonePointerCoarse: window.matchMedia?.('(hover: none) and (pointer: coarse)').matches,
  })
}
